import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';

export const StyledWrapper = styled('div')`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmall};
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            margin-top: ${theme.tggSpacing(rem(2.5), 6.25)};
        }
	`}
`;

export const StyledProgressBar = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: ${theme.tggSpacing([0, rem(1), 0, rem(1)], [0, 2.5, 0, 2.5])};
	`}

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        ${({ theme }: { theme: Theme }) => `
            margin: ${theme.tggSpacing([0, rem(2.5), 0, rem(2.5)], [0, 6.25, 0, 6.25])};
	    `}

        ${({ theme }: { theme: Theme }) => theme.typography.text_12};
    }
`;

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_15_bold_desktop_31};
    ${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.common.blue};

        transform: translateY(${theme.tggSpacing(rem(0.2), 1)});
        ${theme.breakpoints.up('desktop')} {
            transform: translateY(${theme.tggSpacing(rem(0.4), 1)});
        }
	`}
`;
